import React from "react";
import gql from "graphql-tag";
import EntityTitle from "~/components/EntityTitle";
import EntityHeadRow from "~/components/EntityHeadRow";
import {createUseStyles} from "react-jss";
import {primaryTextColor, secondaryTextColor, smallFontSize} from "~/theme";
import UILink from "~/old-ui/UILink";
import {externalUrl} from "~/utils";
import UILabel from "../old-ui/UILabel";
import {isTrialUnlimited} from "../types/account";

export default function AccountHead({account, ...props}) {
  const classes = useStyles();

  return (
    <div {...props}>
      <EntityTitle
        loading={account === null}
        title={account && account.name}
        subtitle={account && account.__typename}
      />
      <EntityHeadRow
        label='Status'
        loading={account === null}
        value={account && (
          account.active ? <UILabel success>active</UILabel> : <UILabel danger>inactive</UILabel>
        )}
      />
      {account && account.isTrial && (
        <EntityHeadRow
          label='Trial'
          value={(<><UILabel warning>trial</UILabel> {!isTrialUnlimited(account) && <>Ends in {account.trial.endsIn} days</>} </>)}
        />
      )}
      <EntityHeadRow
        label='Actions'
        loading={account === null}
        value={account && (
          <UILink href={externalUrl(`/account/switch/${account.id}`)}>Log under {account.name}</UILink>)}
      />
    </div>
  )
}

AccountHead.fragments = {
  account: gql`
    fragment AccountHead on Account {
      id
      __typename
      name
      active
      image
      isTrial
      trial {
        endsIn
      }
    }
  `
};

const useStyles = createUseStyles({
  value: {
    display: 'flex',
    alignItems: 'center',
    color: primaryTextColor,
    border: 0,
  },
  noValue: {
    color: secondaryTextColor,
  },

  valueRow: {
    display: 'flex',
  },

});
